<template>
  <div>
    <div class="icon-content">
      <img class="icon-tip" :src="appData.merJumpBackgroundUrl" />

      <div class="click-content">
        <wx-open-launch-weapp id="launch-btn">
          <!-- <script type="text/wxtag-template">
            <style>.btn {
                background-color: white;
                border-radius: 10px;
                color: var(--primary-color);
                font-size: 16px;
                height: 50px;
                padding: 25px 80px;
                white-space: nowrap;
                display: flex;
                align-items: center;
                justify-content: center;
                border: none; }</style>
            <button class="btn"> 进入控制台</button>
          </script> -->
        </wx-open-launch-weapp>
      </div>
    </div>
  </div>
</template>

<script>
import { getWXAuthInfor, getDeviceAuthInfo } from "@/api/home";
import { Toast } from "vant";
import { Dialog } from "vant";

export default {
  data() {
    return {
      deviceSN: "",
    };
  },

  mounted() {
    this.deviceSN = this.$route.query.deviceSN;

    this.getDeviceAuthInfoAction();

    const cookie = document.cookie;
    const encodedCookie = encodeURIComponent(cookie);
    let launchBtn = document.getElementById("launch-btn");
    let myPath = `pages/control/index?cookie=${encodedCookie}`;
    launchBtn.setAttribute("path", myPath);
    launchBtn.setAttribute("appid", this.appData.merAppletAppid);
    // 清空原有内容
    launchBtn.innerHTML = "";
    // 创建 script 标签
    const script = document.createElement("script");
    script.type = "text/wxtag-template";
    script.textContent = `
    <style>
      .btn {
        background-color: white;
        border-radius: 10px;
        color: ${this.appData.merThemeColor};
        font-size: 16px;
        height: 50px;
        padding: 25px 80px;
        white-space: nowrap;
        display: flex;
        align-items: center;
        justify-content: center;
        border: none;
      }
    </style>
    <button class="btn">进入控制台</button>
  `;
    launchBtn.appendChild(script);
    //配置微信授权
    this.uppdateWXConfigAction();
  },

  methods: {
    uppdateWXConfigAction() {
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
      });

      getWXAuthInfor().then((res) => {
        this.$wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: res.appId, // 必填，公众号的唯一标识
          timestamp: res.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.noncestr, // 必填，生成签名的随机串
          signature: res.signature, // 必填，签名
          jsApiList: ["scanQRCode"], // 必填，随意一个接口即可
          openTagList: ["wx-open-launch-weapp"], // 填入打开小程序的开放标签名
        });

        this.$wx.ready(() => {
          this.$toast.clear();
        });
      });
    },

    getDeviceAuthInfoAction() {
      getDeviceAuthInfo({
        sn: this.deviceSN,
      }).then((res) => {
        const ispNetworkList = res.ispNetwork || [];

        const ispMap = {
          T: "电信",
          M: "移动",
          U: "联通",
        };

        // 找出存在认证的运营商
        const unCertifyIspNames = ispNetworkList
          .filter((item) => item.certifyState === 1)
          .map((item) => ispMap[item.isp] || "未知运营商");

        if (ispNetworkList.length > 0 && unCertifyIspNames.length === 0) {
          Dialog.alert({
            title: "提示",
            message: "运营商实名登记未完成，请先前往实名登记！",
            confirmButtonText: "立即前往",
            confirmButtonColor: "var(--primary-color)",
          }).then(() => {
            this.uni.navigateTo(
              "/home/auth?sn=" + this.deviceSN + "&isBefore=1"
            );
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.icon-content {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: var(--primary-color);
  .icon-tip {
    width: 100%;
    display: block;
  }

  .click-content {
    position: absolute;
    bottom: 150px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    pointer-events: none; // 不影响图片点击
  }

  #launch-btn {
    pointer-events: auto; // 保证按钮能点击
  }
}
</style>
